export default __webpack_public_path__ + "static/media/logo.256c12ca.png";